import { Link, router } from "@inertiajs/react"
import { LogOut, Settings } from "lucide-react"

import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { UserInfo } from "@/components/user-info"
import { settingsProfilePath, signOutPath } from "@/routes"
import type { User } from "@/types"

/** Cleans up pointer-events style left by mobile navigation sheet. */
function cleanupMobileNavigation() {
  document.body.style.removeProperty("pointer-events")
}

interface UserMenuContentProps {
  auth: {
    user: User
  }
}

export function UserMenuContent({ auth }: UserMenuContentProps) {
  const { user } = auth

  const handleLogout = () => {
    cleanupMobileNavigation()
    router.flushAll()
  }

  return (
    <>
      <DropdownMenuLabel className="p-0 font-normal">
        <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
          <UserInfo user={user} showEmail={true} />
        </div>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuGroup>
        <DropdownMenuItem asChild>
          <Link
            className="block w-full"
            href={settingsProfilePath()}
            as="button"
            prefetch
            onClick={cleanupMobileNavigation}
          >
            <Settings className="mr-2" />
            Settings
          </Link>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <Link
          className="block w-full"
          method="delete"
          href={signOutPath()}
          as="button"
          onClick={handleLogout}
        >
          <LogOut className="mr-2" />
          Sign Out
        </Link>
      </DropdownMenuItem>
    </>
  )
}
